import script from "./MyLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyLoading.vue?vue&type=script&lang=ts&setup=true"

import "./MyLoading.vue?vue&type=style&index=0&id=893184e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-893184e4"]])

export default __exports__